export enum WellbeingColorCodes {
  DarkGreen = '#31A05F',
  Green = '#58D289',
  LightGreen = '#80ED99',
  Yellow = '#ffe600',
  Red = '#d10000'
};

export enum WellbeingColors {
  DarkGreen = 'dark-green',
  Green = 'green',
  LightGreen = 'light-green',
  Yellow = 'yellow',
  Red = 'red'
};